import { useState } from 'react'
import { LogIn } from 'lucide-react'
import { SignInDialog } from '@/auth/SignInDialog'
import { useAuth } from '@/auth/useAuth'
import { isSupabaseConfigured } from '@/repository/supabase/client'

/**
 * Compact header entry point for the magic-link sign-in flow. Hidden
 * when Supabase isn't configured (offline build / local dev without
 * `.env.local`) so it doesn't render an inert button in local mode.
 */
export function SignInButton() {
  const [open, setOpen] = useState(false)
  const { isLoading } = useAuth()

  if (!isSupabaseConfigured()) return null
  if (isLoading) return null

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-sm font-medium transition-colors"
      >
        <LogIn className="w-4 h-4" />
        Sign in
      </button>
      <button
        onClick={() => setOpen(true)}
        className="sm:hidden p-2 text-slate-300 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
        aria-label="Sign in"
        title="Sign in"
      >
        <LogIn className="w-5 h-5" />
      </button>
      <SignInDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}
